import $ from 'jquery'
import Splide from '@splidejs/splide'
import 'parsleyjs'
import 'parsleyjs/src/i18n/fr'
import { Alert } from '../functions'


// eslint-disable-next-line no-undef
const { __ } = wp.i18n

const object = vnObject

if ( $('.js-register-slider').length != 0 ) {
    var registerSplide = new Splide( '.js-register-slider', {
        arrows: false,
        drag: false,
    } );

    registerSplide.mount();

    registerSplide.on('moved', function () {
        var activeIndex = registerSplide.index;
        var $paginationPages = $('.js-register-slider .splide__pagination__page');
        $paginationPages.each(function (index) {
            if (index < activeIndex) {
                $(this).addClass('is-passed');
            } else {
                $(this).removeClass('is-passed');
            }
        });
    });

    $('.js-register-first').on( 'click', function(e) {
        e.preventDefault()
        var email = $('#email').val();
        var emailConfirm = $('#email-confirm').val();
        var password = $('#password').val();
        var passwordConfirm = $('#password-confirm').val();
        if (email === '' || emailConfirm === '' || password === '' || passwordConfirm === '') {
            Alert(false, object.formFill)
        } else {
            registerSplide.go('>')
        }
    })

    $('.js-register-second').on( 'click', function(e) {
        e.preventDefault()
        var lastname = $('#phone_number').val();
        var name = $('#name').val();
        var phone_number = $('#phone_number').val();
        var address = $('#address').val();
        var postal_code = $('#postal_code').val();
        var city = $('#city').val();
        if (lastname === '' || name === '' || phone_number === '' || address === '' || postal_code === '' || city === '') {
            Alert(false, object.formFill)
        } else {
            registerSplide.go('>')
        }
    })

    $('.js-register-prev').on( 'click', function(e) {
        e.preventDefault()
        registerSplide.go('<')
    })
}


const form = $('.register-form')
const formSubmit = $('.js-send-register-form')

if (form.length) {
    form.parsley().on('form:success', function () {
        form.attr('data-success', 'true')
    })

    form.parsley().on('form:error', function () {
        form.attr('data-success', 'false')
    })

    formSubmit.on('click', function (e) {
        e.preventDefault()
        e.stopPropagation()

        const formData = new FormData(form[0])
        formData.append('action', 'vn_register')
        formData.append('nonce', object.nonce)

        const $form = form
        $.ajax({
            url: object.ajaxUrl,
            type: 'POST',
            data: formData,
            beforeSend: () => {
                $form.addClass('sending')
                Alert('warning', object.formWait, false)
            },
            processData: false,
            contentType: false,
            success: (res) => {
                $form.removeClass('sending')

                if (res.data.return_to_slide || res.data.return_to_slide === 0) {
                    Alert().close()
                    registerSplide.go(res.data.return_to_slide)
                }

                Alert(res.success, res.data.message)
                res.success && $form[0].reset()
            },
        })
    })
}
